import {
  ALPHANUMERIC_REGEX,
  ALPHANUMERIC_SPECIAL_REGEX,
  EMAIL_REGEX,
  MIN_LETTERS_REGEX,
  MIN_NUMBERS_REGEX,
  NO_CONSECUTIVE_REGEX,
  PHONE_REGEX,
} from "libraries/yup/regex";
import { number, object, string } from "yup";

export const userSchema = object({
  name: string()
    .min(3, "El nombre debe tener al menos 3 caracteres")
    .max(100, "El nombre no puede tener más de 100 caracteres")
    .matches(ALPHANUMERIC_REGEX, "El nombre debe ser alfanumérico")
    .matches(
      NO_CONSECUTIVE_REGEX,
      "El nombre no debe tener caracteres especiales o espacios consecutivos",
    )
    .required("El nombre es obligatorio"),

  country: string()
    .min(3, "El país debe tener al menos 3 caracteres")
    .max(100, "El país no puede tener más de 100 caracteres")
    .matches(
      NO_CONSECUTIVE_REGEX,
      "El país no debe tener caracteres especiales o espacios consecutivos",
    )
    .required("El país es obligatorio"),

  city: string()
    .min(3, "La ciudad debe tener al menos 3 caracteres")
    .max(100, "La ciudad no puede tener más de 100 caracteres")
    .matches(
      NO_CONSECUTIVE_REGEX,
      "La ciudad no debe tener caracteres especiales o espacios consecutivos",
    )
    .required("La ciudad es obligatoria"),

  fiscalId: number()
    .positive("El dato fiscal debe ser un número positivo")
    .typeError("El dato fiscal debe ser numérico")
    .required("El dato fiscal es obligatorio"),

  phoneNumber: string()
    .matches(
      PHONE_REGEX,
      'El teléfono debe tener un formato válido y comenzar con "+"',
    )
    .required("El teléfono es obligatorio"),

  address: string()
    .min(3, "La dirección debe tener al menos 3 caracteres")
    .matches(
      MIN_LETTERS_REGEX(3),
      "La dirección debe contener al menos 3 letras",
    )
    .matches(
      MIN_NUMBERS_REGEX(1),
      "La dirección debe contener al menos 1 número",
    )
    .matches(
      ALPHANUMERIC_SPECIAL_REGEX,
      "La dirección debe tener un formato válido",
    )
    .matches(
      NO_CONSECUTIVE_REGEX,
      "La dirección no debe tener caracteres especiales o espacios consecutivos",
    )
    .required("La dirección es obligatoria"),

  email: string()
    .matches(EMAIL_REGEX, "El email debe tener un formato válido")
    .required("El email es obligatorio"),

  containersAmount: number()
    .positive("La cantidad debe ser un número positivo")
    .typeError("La cantidad debe ser numérica")
    .min(1, "Debe haber al menos 1 contenedor habilitado")
    .max(100, "No puedes habilitar más de 100 contenedores.")
    .required("La cantidad de contenedores es obligatoria"),

  slotsAmount: number()
    .positive("La cantidad debe ser un número positivo")
    .typeError("La cantidad debe ser numérica")
    .min(1, "Debe haber al menos 1 cascos habilitado")
    .required("La cantidad de cascos es obligatoria"),
}).noUnknown();
